import React from 'react';
import ConfiguratorPageAndContent from './ConfiguratorPageAndContent.react';
import ConfiguratorLeftCol from './ConfiguratorLeftCol.react';
import {connect} from 'react-redux'
import * as ConfiguratorActions from '../actions/configurator'
import Progress from './layout/Progress.react';
import ConfiguratorManager from '../ConfiguratorManager';
import { DragDropContext } from 'react-dnd';
// import HTML5Backend from 'react-dnd-html5-backend';
import HTML5Backend from 'react-dnd-html5-touch-backend';
import TouchBackend from 'react-dnd-touch-backend';
import flow from 'lodash/flow';
import {FormattedMessage, injectIntl} from 'react-intl';
import Joyride from 'react-joyride';
import './../../../dist/theme/src/react-joyride-compiled.css'
import ConfirmModal from './ConfirmModal.react';
import ReactDOM from 'react-dom';


class Configurator extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            joyrideOverlay: true,
            joyrideType: 'continuous',
            isRunning: false,
            autoStart: false,
            stepIndex: 0,
            steps: [],
            selector: '',
            countMountedSubComponents: 0,
            firstVisitConfigurator: true
        };
    }


    static get defaultProps() {
        return {
            documentId: 0,
            storageId: 0,
            pageId: 0,
            isCopy: 0,
        }
    }

    componentWillMount() {
        let {dispatch} = this.props;
        //changed
        let {documentId, storageId, pageId, isCopy} = this.props.routeParams;

        dispatch(ConfiguratorActions.getConfiguratorDataByDocument(documentId));

        const firstVisitConfigurator = this.checkFirstVisitConfigurator();

        this.setState ({
            firstVisitConfigurator: firstVisitConfigurator,
        });
    }

    componentDidMount() {

        const steps = [
            {
                title: <FormattedMessage id='TEXT_FEATURE_TOUR_CONFIGURATOR_TITLE_1'/>,
                text: <FormattedMessage id='TEXT_FEATURE_TOUR_CONFIGURATOR_MESSAGE_1'/>,
                selector: '.configurator-content',
                position: 'bottom'
            }
        ];

        this.addSteps(steps);
    }

    /** Callback function for the sub components to check for readiness */
    checkSubcomponentMounted () {
        this.setState({
            countMountedSubComponents: ++this.state.countMountedSubComponents
        });

        /*if (this.state.countMountedSubComponents >= 2) {
            if(this.state.firstVisitConfigurator) {
                this.startTour();
            }
        }*/
    }

    /** Checks if user visits the configurator page for the first time*/
    checkFirstVisitConfigurator() {

        if (localStorage.getItem("firstVisitConfigurator") === null) {
            localStorage.setItem("firstVisitConfigurator", false);
            return true;
        } else {
            return false;
        }
    }


    /** Feature Tour Steps*/
    addSteps(steps) {

        let newSteps = steps;

        if (!Array.isArray(newSteps)) {
            newSteps = [newSteps];
        }

        if (!newSteps.length) {
            return;
        }

        // Force setState to be synchronous to keep step order.
        this.setState(currentState => {
            currentState.steps = currentState.steps.concat(newSteps);
            return currentState;
        });
    }

    /** Starts Feature Tour*/
    startTour() {

        if (!this.state.isRunning) {
            // first time
            this.setState({
                isRunning: true,
                autoStart: true
            });
        } else {
            this.refs.joyride.reset(true);
        }
    }

    /** Feature Tour Events*/
    callback(data) {
        // resets tour data after closing
        if(data.action === 'close') {
            this.refs.joyride.reset();
        }
    }

    render() {

        const {documentId, storageId, pageId, isCopy} = this.props.routeParams;
        const {documentStorage, configurator} = this.props;
        const {
            isRunning,
            autoStart,
            joyrideOverlay,
            joyrideType,
            stepIndex,
            steps
        } = this.state;

        if (documentStorage.loaded === false || configurator.data.length === 0) {
            return <Progress/>;
        }

        let lockOverlay = null;
        if (documentStorage.loading === true) {
            lockOverlay = <div className="configurator-lock-overlay"></div>
        }

        let authorId=null;
        documentStorage.data.map(ds => {
            if (ds.id.toString() === storageId.toString() ) {
                authorId = ds.authorId;
            }
        });

        //changed
        const CM = new ConfiguratorManager(configurator, documentStorage, documentId, storageId, pageId, authorId, isCopy);

        const validatePage = (pageId, callback) => {

            const validate = CM.validate(pageId);
            // console.log('A11 - validatePage', validate);

            if (validate.success === false) {

                // console.log('A11 - validatePage -> success = false');

                let errors = <ul>
                    {validate.errorMessages.map(entry => {
                        return <li>{entry}</li>
                    })}
                </ul>;

                let data = {
                    title: this.props.intl.formatMessage({id: 'LABEL_PAGE_NOT_VALID'}).toString(),
                    msg: errors,
                    cancelMsg: this.props.intl.formatMessage({id: 'LABEL_PROCEED_ANYWAY'}).toString(),
                    okMsg: this.props.intl.formatMessage({id: 'LABEL_OK'}).toString(),
                    callbackCancel: callback
                };

                ReactDOM.render(<ConfirmModal openModal={true} data={data}/>, document.getElementById('confirm-modal-overlay'));

            } else {
                // console.log('A11 - validatePage -> success = true .... exec callback()');
                callback();
            }
        };

        // Hack, to refresh title outsite of the react root!
        const navbarLeftHtml = '<li><a href="/#/dashboard"><i class="material-icons">home</i></a></li>' +
            '<li><p>&raquo;</p></li>' +
            '<li><p>' + CM.getDocumentStorageTitle() + '</p></li>';
        document.getElementById('navbarLeft').innerHTML = navbarLeftHtml;

        return (
            <div>
                { lockOverlay }
                <Joyride
                    ref="joyride"
                    callback={this.callback.bind(this)}
                    disableOverlay={false}
                    locale={{
                        back: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_BACK"/></span>),
                        close: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_CLOSE"/></span>),
                        last: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_LAST"/></span>),
                        next: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_NEXT"/></span>),
                        skip: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_SKIP"/></span>),
                    }}
                    run={isRunning}
                    autoStart={autoStart}
                    showOverlay={joyrideOverlay}
                    showSkipButton={true}
                    showStepsProgress={true}
                    stepIndex={stepIndex}
                    steps={steps}
                    type={joyrideType}
                />
                {/*<div onClick={this.startTour.bind(this)} className="joyride-start-area joyride-navbar-button">
                    <i className="material-icons joyride-start-icon">help</i>
                    <FormattedMessage id="LABEL_FEATURE_TOUR"/>
                </div>*/}
                <div className="configurator-content" >
                    <div className="sidebar">
                        <ConfiguratorLeftCol
                            ConfiguratorManager={CM}
                            checkSubcomponentMounted={this.checkSubcomponentMounted.bind(this)}
                            addSteps={this.addSteps.bind(this)}
                            validatePage={validatePage}
                        />
                    </div>
                    <ConfiguratorPageAndContent
                        ConfiguratorManager={CM}
                        checkSubcomponentMounted={this.checkSubcomponentMounted.bind(this)}
                        addSteps={this.addSteps.bind(this)}
                        validatePage={validatePage}
                    />
                </div>
                <div id="confirm-modal-overlay"></div>
            </div>
        );
    }
}

export default flow(
    plskIsTouchDevice ? DragDropContext(TouchBackend({ enableMouseEvents: true })) : DragDropContext(HTML5Backend),
    connect(state => ({configurator: state.configurator, documentStorage: state.documentStorage}))
)(injectIntl(Configurator));



// WEBPACK FOOTER //
// ./src/js/components/Configurator.react.jsx